import React from 'react';
import { Dialog } from '@material-ui/core';

const ApproveDialog = ({ Form, show }) => {
  return (
    <Dialog open={show} disableBackdropClick >
       <Form />
    </Dialog>
  )
}

export default ApproveDialog;